<template>
  <div>
    <div style="margin-top: 40px; margin-left: 0">
      Для безопасной работы с биржей АЕ придерживайтесь следующих правил:<br/>
      <div class="myParagraph">1.Храните ключ торгового терминала на носителе в месте, недоступном посторонним лицам.
      </div>
      <div class="myParagraph">2.Исключите хранение ключей</div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        на жёстком диске
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        в сетевых каталогах
      </div>
      <div style="margin: 12px 0px 0px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        облаке и прочих общедоступных ресурсах
      </div>

      <div class="myParagraph">3.Используйте сложный пароль</div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        цифры
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        буквы
      </div>
      <div style="margin: 12px 0px 0px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        спец. символы
      </div>
      <div class="myParagraph">4.Храните в тайне пароль к торговому терминалу и личному кабинету АЕ</div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        исключите запись пароля в открытом виде
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        никому не сообщайте пароль, даже специалистам службы поддержки АЕ.
      </div>
      <div style="width: 765px;margin-bottom: 20px; margin-top: 25px ; position: relative; " class="lk_content_info_block">

        <div style="display: table-cell; width: 70px">
         <el-icon
              style="
                font-size: 50px;
                position: absolute;
                transform: rotate(180deg);
                left: 20px;
                color: #e82862;
              "
              ><Warning
            /></el-icon>
        </div>
        <div style="display: table-cell;">

          По возможности используйте при регистрации отдельный email который известен только вам. <br> При вводе и
          выводе средств проверяйте адреса криптовалютных кошельков.<br>
          При обнаружении подозрительных транзакций незамедлительно обращайтесь в поддержку АЕ! client@ae.exchange
        </div>
      </div>

      <div class="myParagraph">5.Соблюдайте общие правила безопасности, применяющиеся для защиты данных, хранящихся на
        компьютерах:
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        Используйте только доверенные компьютеры с лицензионными программами, установленным антивирусом.
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        Регулярно проверяйте компьютер на вирусы, обновляйте операционную систему, браузеры и антивирусные базы.
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        При работе с электронной почтой не открывайте письма, полученные от неизвестных отправителей, и вложения к
        ним, не переходите по ссылкам из таких писем.
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        Не используйте права администратора без крайней необходимости. В повседневной практике входите в систему, как
        пользователь без прав администратора.
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        При работе в Интернет не соглашайтесь на установку дополнительных программ.
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        По возможности используйте выделенный компьютер только для работы с торговым терминалом и личным кабинетом
        биржи АЕ.
      </div>
      <div style="margin: 12px 0px">
        <svg style="padding: 3px 18px 3px 0px" width="20" height="2" viewBox="0 0 20 2" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 1H20" stroke="#E82862" stroke-width="2"/>
        </svg>
        Не сохраняйте логин и пароль на общедоступных компьютерах/терминалах.
      </div>

    </div>
  </div>
</template>

<script>
import { Warning } from "@element-plus/icons-vue";
export default {
  name: "SafetyRegulations",
  components:{Warning}
}
</script>

<style scoped>
.myParagraph {
  padding-top: 30px;
  font-family: "Proxima Nova";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #222222;
}
</style>